import { User } from "../models/user";

export interface MenuFeature {
    name: string;
    icon: string;
    route?: string;
    className: string;
    children?: MenuFeature[]; 

}

export class FeatureBuilder {
    private features: MenuFeature[] = [];

    constructor(private user: User) { }

    build() {
        switch (this.user.rolName) {
            case "GER":
            case "ADM":
            case "COL":
                this.features.push(
                    { name: 'Notificaciones', icon: 'fa fa-bell', route: '/members/notifications', className: 'notifications' },
                );
                if (this.user.storeId) {
                    this.features.push(
                        { name: 'Productos', icon: 'fa fa-rocket', route: '/members/product', className: 'product' },
                    )

                    if (!this.user.subsidiaryId) {
                        this.features.push(
                            { name: 'Categorías', icon: 'fa fa-bars', route: '/members/category', className: 'category' },
                            { name: 'Banners', icon: 'fa fa-certificate', route: '/members/banner', className: 'banner' },
                            { name: 'Sucursal', icon: 'fa fa-shopping-basket', route: '/members/subsidiary', className: 'subsidiary' },
                        )
                    }
                }
                else {
                    if (!this.user.subsidiaryId) {
                        this.features.push(
                            { name: 'Tiendas', icon: 'fa fa-area-chart', route: '/members/store', className: 'store' },
                            {
                                name: 'Search',
                                icon: 'fa fa-search', 
                                className: 'search-module',
                                children: [
                                    { name: 'Reglas de Relevancia', icon: 'fa fa-sliders', route: '/members/relevance-rules', className: 'relevance-rules' }
                                ]
                            }
                        );

                    }
                }

                if (!this.user.subsidiaryId) {
                    this.features.push(
                        { name: 'Usuarios', icon: 'fa fa-user', route: '/members/user', className: 'user' },
                    )
                }

                this.features.push(
                    { name: 'Cambiar contraseña', icon: 'fa fa-unlock-alt', route: '/members/password', className: 'change-pass' },
                );

                return this.features;

            case "ECO":
                this.features.push(
                    { name: 'Notificaciones', icon: 'fa fa-bell', route: '/members/notifications', className: 'notifications' },
                );
                if (this.user.storeId) {
                    this.features.push(
                        {
                            name: 'Search',
                            icon: 'fa fa-search', 
                                className: 'search-module',
                            children: [
                              {
                                name: 'Redirecciones',
                                icon: 'fa fa-sitemap',
                                route: '/members/search-redirect',
                                className: 'redirect'
                              },
                              { name: 'Reglas de Relevancia', icon: 'fa fa-sliders', route: '/members/relevance-rules', className: 'relevance-rules' }
                            ]
                          },
                        { name: 'Productos', icon: 'fa fa-rocket', route: '/members/product-v2', className: 'product-v2' },
                    )
                    if (!this.user.subsidiaryId) {
                        this.features.push(
                            { name: 'Categorías', icon: 'fa fa-bars', route: '/members/category-v2', className: 'category-v2' },
                        )
                    }
                    this.features.push(
                        { name: 'Marcas', icon: 'fa fa-superpowers', route: '/members/brand', className: 'brand' },
                        { name: 'Colecciones', icon: 'fa fa-bullseye', route: '/members/collections', className: 'collections' },
                        { name: 'Importar y Exportar', icon: 'fa fa-exchange', route: '/members/import-export', className: 'import-export' },
                        { name: 'Precios', icon: 'fa fa-money', route: '/members/price', className: 'price' },
                        { name: 'Seller', icon: 'fa fa-id-card', route: '/members/seller', className: 'seller' },                       
                        { name: 'Stock', icon: 'fa fa-cubes', route: '/members/stock', className: 'stock' },
                        { name: 'Atributos', icon: 'fa fa-list-alt', route: '/members/attributes', className: 'attributes' },
                        { name: 'Redirecciones', icon: 'fa fa-sitemap', route: '/members/redirect', className: 'redirect' }
                        
                    )
                }
                else {
                    if (!this.user.subsidiaryId) {
                        this.features.push(
                            { name: 'Tiendas', icon: 'fa fa-area-chart', route: '/members/store', className: 'store' },
                        )
                    }
                }
                this.features.push(
                    { name: 'Cambiar contraseña', icon: 'fa fa-unlock-alt', route: '/members/password', className: 'change-pass' },
                );
                return this.features;

            default:
                return this.features;
        }
    }
}